import { type MetaFunction } from '@remix-run/node'
import { Link } from '@remix-run/react'

export const meta: MetaFunction = () => [
	{ title: 'Delete account & data - MinHub' },
	{
		name: 'description',
		content:
			'Request deletion of your MinHub account and personal information. We process requests in line with our Privacy Policy.',
	},
]

const SUPPORT_EMAIL = 'support@minhub.app'
const mailtoHref = `mailto:${SUPPORT_EMAIL}?subject=${encodeURIComponent(
	'MinHub account and data deletion request',
)}&body=${encodeURIComponent(
	`Please delete my MinHub account and associated personal data.

Email I use to sign in to MinHub:


Full name (optional):


Additional context (optional):


`,
)}`

export default function DeleteAccountRoute() {
	return (
		<div className="mx-auto max-w-4xl px-4 py-16">
			<h1 className="mb-4 text-4xl font-bold">Delete your account and data</h1>
			<p className="text-muted-foreground mb-10 text-base leading-7">
				You can ask us to delete your MinHub account and the personal information we hold about you.
				We handle requests under our{' '}
				<Link to="/privacy" className="font-semibold text-primary underline hover:no-underline">
					Privacy Policy
				</Link>
				.
			</p>

			<section className="mb-10 space-y-4 text-base leading-7">
				<h2 className="text-2xl font-semibold">How to request deletion</h2>
				<p>
					Send an email from the address you use to sign in to MinHub (or clearly state that address in
					the message) so we can verify your request. We aim to process deletion requests within 30 days.
				</p>
				<p>
					Deleting your account permanently removes your personal data from our systems where we are not
					required to keep it for legal or legitimate business reasons (for example, certain billing
					records).
				</p>
				<p className="font-medium text-darkGrey">
					This cannot be undone. Content you created in ministries you belong to may also be removed or
					anonymized according to how those ministries use MinHub.
				</p>
			</section>

			<div className="rounded-lg border border-lightGrey bg-white p-6 shadow-sm">
				<p className="mb-4 text-base font-semibold text-darkGrey">Email support</p>
				<a
					href={mailtoHref}
					className="inline-flex items-center justify-center rounded-md border-2 border-secondary bg-secondary px-5 py-2.5 text-base font-semibold text-white transition-colors hover:bg-white hover:text-secondary"
				>
					Request deletion by email
				</a>
				<p className="mt-4 text-sm text-grey">
					Opens your email app addressed to {SUPPORT_EMAIL} with a template you can edit before sending.
				</p>
			</div>

			<p className="mt-10 text-sm text-grey">
				Questions? You can also reach us at{' '}
				<a href={`mailto:${SUPPORT_EMAIL}`} className="font-semibold text-primary underline hover:no-underline">
					{SUPPORT_EMAIL}
				</a>
				.
			</p>
		</div>
	)
}
